// extracted by mini-css-extract-plugin
module.exports = {"closeModalButton":"Terms_closeModalButton__nmE8w","termsOfUseContainer":"Terms_termsOfUseContainer__14dix"};